<div><app-navbar *ngIf="isA"></app-navbar></div>

<div class="row mt-4 justify-content-center align-items-center">
  <div class="col-md-8">
    <router-outlet></router-outlet>
  </div>
</div>

<footer *ngIf="isA" class="row text-center mt-4">
  <p>&copy; {{ year }} PersonnelPulse. All rights reserved.</p>
</footer>
